import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { SITE, LAUNCH } from "@/data/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DEFAULTS = {
  coming_soon: LAUNCH.comingSoon,
  coming_soon_message: LAUNCH.message,
  checkout_message: LAUNCH.checkoutMessage,
  sale_banner_enabled: false,
  sale_banner_text: "",
  logo: "",
  hero_image: "",
  images: {},
  family_video: "",
  email: SITE.email,
  phone: SITE.phone,
  whatsapp: SITE.whatsapp,
  hours: SITE.hours,
  address: SITE.address,
  social: SITE.social,
};

const SettingsContext = createContext(DEFAULTS);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULTS);
  useEffect(() => {
    axios.get(`${API}/settings`).then(({ data }) => setSettings({ ...DEFAULTS, ...data })).catch(() => {});
  }, []);
  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
};

export const useSettings = () => useContext(SettingsContext);
